import React, { useState, useEffect, ReactNode, createContext } from 'react';

import { useWalletClient, usePublicClient } from 'wagmi';
import { contractAddresses } from '../helpers/config/contracts.config';
import { getContract } from 'viem';
import ddpAbi from '../abi/ddp.json';
import usdtAbi from '../abi/usdtPolygon.json';
import nrsAbi from '../abi/nrsPolygon.json';
import veNrsAbi from '../abi/veNrsPolygon.json';
import nrsRewardControllerAbi from '../abi/nrsRewardControllerPolygon.json';
import nrsWithdrawalTimelockAbi from '../abi/nrsWithdrawalTimelockPolygon.json';


type ContractProviderProps = {
    children: ReactNode;
};

type ContractsContextType = {
    ddpContract: any | null;
    usdtContract: any | null;
    nrsContract: any | null;
    veNrsContract: any | null;
    nrsRewardControllerContract: any | null;
    nrsWithdrawalTimelockContract: any | null;
};


export const ContractContext = createContext<ContractsContextType>(
    { ddpContract: null, usdtContract: null, nrsContract: null, veNrsContract: null, nrsRewardControllerContract: null, nrsWithdrawalTimelockContract: null });

const ContractsProvider: React.FC<ContractProviderProps> = ({ children }) => {
    const [ddpContract, setDdpContract] = useState<any | null>(null);
    const [usdtContract, setUsdtContract] = useState<any | null>(null);
    const [nrsContract, setNrsContract] = useState<any | null>(null);
    const [veNrsContract, setVeNrsContract] = useState<any | null>(null);
    const [nrsRewardControllerContract, setNrsRewardControllerContract] = useState<any | null>(null);
    const [nrsWithdrawalTimelockContract, setNrsWithdrawalTimelockContract] = useState<any | null>(null);
    const { data: signer } = useWalletClient();
    const provider = usePublicClient();

    useEffect(() => {

        const ddpInstance = (getContract as any)({
            address: contractAddresses.polygon.ddp,
            abi: ddpAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });

        setDdpContract(ddpInstance)

        const usdtInstance = (getContract as any)({
            address: contractAddresses.polygon.usdt,
            abi: usdtAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });
        setUsdtContract(usdtInstance);

        const nrsInstance = (getContract as any)({
            address: contractAddresses.polygon.nrs,
            abi: nrsAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });
        setNrsContract(nrsInstance);

        const veNrsInstance = (getContract as any)({
            address: contractAddresses.polygon.veNrs,
            abi: veNrsAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });
        setVeNrsContract(veNrsInstance);

        const nrsRewardControllerInstance = (getContract as any)({
            address: contractAddresses.polygon.nrsRewardController,
            abi: nrsRewardControllerAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });
        setNrsRewardControllerContract(nrsRewardControllerInstance);

        const nrsWithdrawalTimelockInstance = (getContract as any)({
            address: contractAddresses.polygon.nrsWithdrawalTimelock,
            abi: nrsWithdrawalTimelockAbi,
            client: {
                public: provider,
                wallet: signer
            }
        });
        setNrsWithdrawalTimelockContract(nrsWithdrawalTimelockInstance);

    }, [signer, provider]);

    return (
        <ContractContext.Provider value={{ ddpContract, usdtContract, nrsContract, veNrsContract, nrsRewardControllerContract, nrsWithdrawalTimelockContract }}>
            {children}
        </ContractContext.Provider>
    );
};

export default ContractsProvider;
